import { EmployeeDTO } from '../../interfaces/dto/employee'
import {
  EmployeeProfile,
  EmployeeProfileForm
} from '../../interfaces/views/employee'

const capitalize = (str: string) => {
  if (!str) return

  return str.replace(/\b\w/g, function (l) {
    return l.toUpperCase()
  })
}

function calculateAge(dob: string) {
  const today = new Date()
  const birthDate = new Date(dob)
  const m = today.getMonth() - birthDate.getMonth()
  let age = today.getFullYear() - birthDate.getFullYear()
  if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
    age--
  }
  return age
}

export const mapDTOtoEditMemberForm = (
  employeeDTO: EmployeeDTO
): EmployeeProfileForm => {
  const mailingAddress = employeeDTO.mailing_address
  return {
    firstName: employeeDTO.name?.first_name || '',
    lastName: employeeDTO.name?.last_name || '',
    name: `${employeeDTO.name?.first_name || ''} ${
      employeeDTO.name?.last_name || ''
    }`,
    dateOfBirth: employeeDTO.date_of_birth || '',
    email: employeeDTO.contact_info?.work_email || '',
    streetAddressLine1: mailingAddress.street_1 || '',
    streetAddressLine2: mailingAddress.street_2 || '',
    city: mailingAddress.city || '',
    state: mailingAddress.state || '',
    zip: mailingAddress.zip || '',
    medicareEligible: employeeDTO.medicare_eligible || false,
    otherInsurance: employeeDTO.other_insurance || false
  }
}

export const mapFormToD = (formData: EmployeeProfileForm) => {
  const {
    firstName,
    lastName,
    streetAddressLine1,
    streetAddressLine2,
    city,
    state,
    zip,
    medicareEligible,
    otherInsurance
  } = formData

  const data: Partial<EmployeeDTO> = {
    name: {
      first_name: firstName,
      last_name: lastName
    },
    mailing_address: {
      street_1: streetAddressLine1,
      street_2: streetAddressLine2,
      city,
      state,
      zip
    },
    other_insurance: otherInsurance,
    medicare_eligible: medicareEligible
  }
  return data
}

export const mapDToProfile = (employeeDTO: EmployeeDTO): EmployeeProfile => {
  const mailingAddress = employeeDTO.mailing_address
  let monthlyPremium = +employeeDTO.coverages[0]?.monthly_premium_employee || 0
  let monthlyPremiumEmployer =
    +employeeDTO.coverages[0]?.monthly_premium_employer || 0

  return {
    email: employeeDTO.contact_info.work_email || '-',
    planType: capitalize(employeeDTO.coverages[0]?.plan.metal_tier) as string,
    plan: capitalize(employeeDTO.coverages[0]?.plan.plan_name) || '',
    metalTier: employeeDTO.coverages[0]?.plan.metal_tier || '',
    name: employeeDTO.name.first_name + ' ' + employeeDTO.name.last_name,
    dob: employeeDTO.date_of_birth,
    id: employeeDTO.member_id,
    ssn: employeeDTO.ssn,
    address: `${mailingAddress.street_1} ${mailingAddress.street_2}, ${mailingAddress.city} ${mailingAddress.state}, ${mailingAddress.zip}`,
    medicareEligible: employeeDTO.medicare_eligible ? 'Yes' : 'No',
    otherInsurance: employeeDTO.other_insurance ? 'Yes' : 'No',
    coverageStart: employeeDTO.coverages[0]?.effective_date || '-',
    companyPays: `$${monthlyPremium}`,
    employeePays: `$${monthlyPremiumEmployer}`,
    premium: `$${monthlyPremium + monthlyPremiumEmployer}`,
    covers: `${employeeDTO.dependents.length + 1} people`,
    age: employeeDTO.date_of_birth
      ? calculateAge(employeeDTO.date_of_birth)
      : null,
    profilePic: '',
    empty: ['pending', 'in_progress'].includes(employeeDTO.onboarding_status),
    dependents: employeeDTO.dependents || []
  }
}

// only used on DisenrollEmployeePage, TODO: need to combine somehow with mapDToProfile above
export const mapDtoToProfile = (employeeDTO: EmployeeDTO): EmployeeProfile => {
  let monthlyPremium = +employeeDTO.coverages[0]?.monthly_premium_employee || 0
  let monthlyPremiumEmployer =
    +employeeDTO.coverages[0]?.monthly_premium_employer || 0

  return {
    email: employeeDTO.contact_info.work_email || '-',
    planType: capitalize(employeeDTO.coverages[0]?.plan.metal_tier) as string,
    plan: capitalize(employeeDTO.coverages[0]?.plan.plan_name) || '',
    metalTier: employeeDTO.coverages[0]?.plan.metal_tier || '',
    name: employeeDTO.name.first_name + ' ' + employeeDTO.name.last_name,
    dob: employeeDTO.date_of_birth,
    id: employeeDTO.member_id,
    ssn: employeeDTO.ssn,
    address: `${employeeDTO.home_address.street_1} ${employeeDTO.home_address.street_2}, ${employeeDTO.home_address.city} ${employeeDTO.home_address.zip}, ${employeeDTO.home_address.state}`,
    medicareEligible: employeeDTO.medicare_eligible,
    coverageStart: employeeDTO.coverages[0]?.effective_date || '-',
    companyPays: `$${monthlyPremium}`,
    employeePays: `$${monthlyPremiumEmployer}`,
    premium: `$${monthlyPremium + monthlyPremiumEmployer}`,
    covers: `${employeeDTO.dependents.length + 1} people`,
    age: employeeDTO.date_of_birth
      ? calculateAge(employeeDTO.date_of_birth)
      : null,
    profilePic: '',
    empty: ['pending', 'in_progress'].includes(employeeDTO.onboarding_status),
    dependents: employeeDTO.dependents || [],
    otherInsurance: null
  }
}


